import { useEffect, useState } from 'react';

function useCompanyNavigation(
    companyList,
    companyId,
    nameEvent,
    queryStr,
) {
    const [linkPrev, setLinkPrev] = useState({ link: '', disable: true });
    const [linkNext, setLinkNext] = useState({ link: '', disable: true });

    useEffect(() => {
        if (companyList.length > 0) {
            const idCompanyPrev = companyList[companyList.indexOf(Number(companyId)) - 1];
            const idCompanyNext = companyList[companyList.indexOf(Number(companyId)) + 1];

            if (idCompanyPrev) {
                setLinkPrev((prevState) => ({ ...prevState, link: `/${nameEvent}/${idCompanyPrev}/products${queryStr}`, disable: false }));
            } else {
                setLinkPrev((prevState) => ({ ...prevState, link: '', disable: true }));
            }
            if (idCompanyNext) {
                setLinkNext((prevState) => ({ ...prevState, link: `/${nameEvent}/${idCompanyNext}/products${queryStr}`, disable: false }));
            } else {
                setLinkNext((prevState) => ({ ...prevState, link: '', disable: true }));
            }
        }
    }, [companyList, companyId, nameEvent, queryStr]);

    return {
        linkPrev,
        linkNext,
        setLinkPrev,
        setLinkNext,
    };
}

export default useCompanyNavigation;
